import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-boldest m-0" }, "Account information")
  ])
], -1)
const _hoisted_3 = { class: "collapse show" }
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6 d-flex flex-wrap align-items-center mb-8" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Name", -1)
const _hoisted_8 = { class: "fs-6 fw-bold text-gray-600" }
const _hoisted_9 = { class: "col-md-6 d-flex flex-wrap align-items-center mb-8" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Email Address", -1)
const _hoisted_11 = { class: "fs-6 fw-bold text-gray-600" }
const _hoisted_12 = { class: "card mb-5 mb-xl-10" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-boldest m-0" }, "Change password")
  ])
], -1)
const _hoisted_14 = { class: "collapse show" }
const _hoisted_15 = { class: "card-body border-top p-9" }
const _hoisted_16 = { class: "row mb-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "New password", -1)
const _hoisted_18 = { class: "col-lg-8" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-lg-6 fv-row" }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "col-lg-6 fv-row" }
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"card-footer d-flex justify-content-end py-6 px-9\"><button type=\"submit\" class=\"btn btn-primary\"><span class=\"indicator-label\">Save changes</span><span class=\"indicator-progress\"> Please wait... <span class=\"spinner-border spinner-border-sm align-middle ms-2\"></span></span></button></div>", 1)
const _hoisted_27 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, [
      /*#__PURE__*/_createTextVNode(" Profile Details "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("small", null, "Displayed on the clinic's page on Neoris website")
    ])
  ])
], -1)
const _hoisted_29 = { class: "collapse show" }
const _hoisted_30 = { class: "card-body border-top p-9" }
const _hoisted_31 = { class: "row mb-6" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, [
  /*#__PURE__*/_createTextVNode(" Picture"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, [
    /*#__PURE__*/_createTextVNode("Allowed file types: png, jpg, jpeg"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Max. 2 Mo")
  ])
], -1)
const _hoisted_33 = { class: "col-lg-8" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-10" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "col-2" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "row mb-6" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, [
  /*#__PURE__*/_createTextVNode(" Presentation"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Max. 400 characters")
], -1)
const _hoisted_41 = { class: "col-lg-8 fv-row" }
const _hoisted_42 = { class: "row mb-6" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, [
  /*#__PURE__*/_createTextVNode(" Experience/background"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "E.g. diplomas and experience, max. 200 characters")
], -1)
const _hoisted_44 = { class: "col-lg-8 fv-row" }
const _hoisted_45 = { class: "row mb-6" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Spoken languages", -1)
const _hoisted_47 = { class: "col-lg-8 fv-row" }
const _hoisted_48 = { class: "d-center" }
const _hoisted_49 = { class: "selected d-center" }
const _hoisted_50 = { class: "fv-plugins-message-container" }
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = {
  key: 0,
  class: "alert alert-warning mb-0",
  role: "alert"
}
const _hoisted_53 = {
  key: 1,
  class: "alert alert-success mb-0",
  role: "alert"
}
const _hoisted_54 = /*#__PURE__*/_createStaticVNode("<div class=\"card-footer d-flex justify-content-end py-6 px-9\"><button type=\"submit\" class=\"btn btn-primary\"><span class=\"indicator-label\">Save changes</span><span class=\"indicator-progress\"> Please wait... <span class=\"spinner-border spinner-border-sm align-middle ms-2\"></span></span></button></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.user.firstname) + " " + _toDisplayString(_ctx.user.lastname), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", null, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.user.email), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("form", {
              class: "form",
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.saveNewPassword()), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_Field, {
                          type: "password",
                          name: "password",
                          class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                          placeholder: "New password",
                          modelValue: _ctx.newPassword,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPassword) = $event)),
                          required: ""
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_ErrorMessage, { name: "password" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_Field, {
                          type: "password",
                          name: "passwordConfirmation",
                          class: "form-control form-control-lg form-control-solid",
                          placeholder: "Confirm new password",
                          modelValue: _ctx.newPasswordConfirmation,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPasswordConfirmation) = $event)),
                          required: ""
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_ErrorMessage, { name: "passwordConfirmation" })
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _hoisted_26
            ], 32)
          ])
        ]),
        (_ctx.user.isDoctor && _ctx.user.presentationDraft)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("form", {
                  class: "form",
                  onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.saveProfileDetails()), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("input", {
                              disabled: _ctx.isUploading,
                              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleUserImageUpload($event.target.files[0]))),
                              type: "file",
                              class: "form-control",
                              accept: "image/jpeg,image/png"
                            }, null, 40, _hoisted_36)
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("img", {
                              class: "img-fluid",
                              src: _ctx.user.presentationDraft.image
                                            ? `${_ctx.apiUrl}/doctors-images/${_ctx.user.presentationDraft.image}`
                                            : 'media/avatars/blank.png'
                            }, null, 8, _hoisted_38)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("div", _hoisted_41, [
                        _withDirectives(_createElementVNode("textarea", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.presentationDraft.description) = $event)),
                          maxlength: "400",
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.user.presentationDraft.description]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createElementVNode("div", _hoisted_44, [
                        _withDirectives(_createElementVNode("textarea", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.presentationDraft.experience) = $event)),
                          maxlength: "200",
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.user.presentationDraft.experience]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.user.presentationDraft.spokenLanguages,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.presentationDraft.spokenLanguages) = $event)),
                          options: _ctx.iso6391languages,
                          reduce: (e) => e.code,
                          label: "name",
                          multiple: ""
                        }, {
                          "no-options": _withCtx(() => [
                            _createTextVNode("Search language...")
                          ]),
                          option: _withCtx((option) => [
                            _createElementVNode("div", _hoisted_48, _toDisplayString(option.name), 1)
                          ]),
                          "selected-option": _withCtx((option) => [
                            _createElementVNode("div", _hoisted_49, _toDisplayString(option.name), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "reduce"]),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createVNode(_component_ErrorMessage, { name: "language" })
                          ])
                        ])
                      ])
                    ]),
                    (!_ctx.user.presentationDraft.approved)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, " ⚠️ Modifications made to the presentation are submitted for review to the Neoris team before appearing on Neoris website. "))
                      : (_openBlock(), _createElementBlock("div", _hoisted_53, " This is how your presentation appears on Neoris website. Modifications will be subject to review by Neoris team. "))
                  ]),
                  _hoisted_54
                ], 32)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    : _createCommentVNode("", true)
}